import { useEffect, useState } from 'react';

import {
  CountryViewModel,
  EmployeeIdentificationType,
  EmploymentBoardDecisionLockViewModel,
  EmploymentViewModel,
} from '@fora-monorepo/employer-my-pages-common/types';
import { Assets, Container, Feedback, Flex, Link, Tag, Text, useIsDeviceSize } from '@foradevelopment/fora-ui';
import { isFuture } from '@fora-monorepo/date-utils';

import { AddressDetails, MarkupAndParametersListOld, PersonDetails } from '../EmploymentDetails';
import { MarkupChangesLocked } from '../ManageEmployment';
import { getCountryFromCode } from '../../common/utils';
import { useTypedTranslation } from '../../i18n/i18n';

// TODO: REMOVE FILE MANAGE EMPLOYMENTS

type EmploymentTableRowExpandedContentProps = {
  employment: EmploymentViewModel;
  countries: CountryViewModel[];
  formattedEmployeeId: string;
  localizedIdTypeString: string;
  getHasBoardDecisionLock: () => Promise<EmploymentBoardDecisionLockViewModel | null>;
  editUrl: string;
  markupExpiringText?: string;
};

export const EmploymentTableRowExpandedContentOld = ({
  employment,
  countries,
  editUrl,
  getHasBoardDecisionLock,
  markupExpiringText,
}: EmploymentTableRowExpandedContentProps) => {
  const [boardDecisionLock, setBoardDecisionLock] = useState<EmploymentBoardDecisionLockViewModel | null>(null);
  const [hasFetchedBoardDecisionLock, setHasFetchedBoardDecisionLock] = useState<boolean>(false);
  const { t } = useTypedTranslation();

  const { isMobile } = useIsDeviceSize();

  useEffect(() => {
    getHasBoardDecisionLock().then(lock => setBoardDecisionLock(lock));
    setHasFetchedBoardDecisionLock(true);
  }, [getHasBoardDecisionLock]);

  return (
    <Flex justifyContent="center" paddingBottom={70} paddingTop={50} paddingLeft={20} paddingRight={20}>
      <Container maxWidth={578} width="100%">
        <PersonDetails {...employment.employee} policyNumber={undefined} />

        {employment.employmentEndDate && (
          <Container marginTop={10}>
            <Tag
              text={t(
                isFuture(employment.employmentEndDate)
                  ? 'section.employeeDetails.employmentEndsTag'
                  : 'section.employeeDetails.employmentHasEndedTag',
                { endDate: employment.employmentEndDate }
              )}
              variant="informational"
            />
          </Container>
        )}

        {employment.isInactive && (
          <Feedback type="information" marginTop={30} negativeSideMargins={true}>
            <Text size="small" fontWeight="bold" marginBottom={5}>
              {t('section.employeeDetails.informationAboutEmploymentPeriodsTitle')}
            </Text>
            <Text size="small" whiteSpace="pre-wrap">
              {t('section.employeeDetails.informationAboutEmploymentPeriodsDescription')}
            </Text>
          </Feedback>
        )}

        <Container marginTop={40}>
          {!employment.isInactive && (
            <Link
              to={editUrl}
              styleAs="button"
              hasIcon={false}
              state={{ boardDecisionLock, hasFetchedBoardDecisionLock }}
            >
              {t('common.edit')}
              <Assets.EditIcon color="white" marginLeft={8} />
            </Link>
          )}
          {markupExpiringText && (
            <Feedback type="warning" negativeSideMargins={isMobile ? false : true} marginTop={40}>
              {markupExpiringText}
            </Feedback>
          )}
        </Container>
        <Container marginTop={40}>
          {boardDecisionLock && <MarkupChangesLocked boardDecisionLock={boardDecisionLock} type="feedback" />}
          <MarkupAndParametersListOld markups={employment.markups} activeMarkup={employment.activeMarkup} />
        </Container>

        {employment.employee.identificationType !== EmployeeIdentificationType.PersonalIdentityNumber &&
          employment.employee.address && (
            <Container marginTop={40}>
              <AddressDetails
                title="Adress"
                {...employment.employee.address}
                country={getCountryFromCode(countries, employment.employee.address.countryCode)}
              />
            </Container>
          )}
      </Container>
    </Flex>
  );
};
